import { ColorModeScript } from '@chakra-ui/react'
import * as React from 'react'
import theme from './theme'
import * as ReactDOM from 'react-dom/client'
import { HashRouter } from 'react-router-dom'
import { App } from './App'
import './index.css'

// Force dark mode on initial load
if (localStorage.getItem('chakra-ui-color-mode') !== 'dark') {
    localStorage.setItem('chakra-ui-color-mode', 'dark')
}

const container = document.getElementById('root')
if (!container) throw new Error('Failed to find the root element')
const root = ReactDOM.createRoot(container)

root.render(
    <React.StrictMode>
        <HashRouter>
            <ColorModeScript initialColorMode={theme.config.initialColorMode} />
            <App />
        </HashRouter>
    </React.StrictMode>
)
